import { useMutation } from '@tanstack/react-query';
import { App } from 'antd';
import { handleError } from 'api';
import { PackageApiService } from 'features/package/api/package-api.service';
import { queryClient } from 'providers';

import { packageQueryKeys } from './query.keys';
const { deletePackageCoverImage } = PackageApiService();

export const useDeletePackageCoverImage = () => {
  const { message } = App.useApp();

  return useMutation(
    (id: string) => {
      return deletePackageCoverImage(id);
    },
    {
      onError: (error) => {
        const uiMessage = handleError(error);

        console.error(uiMessage);
        message.error(
          'The Package has been successfully created, but gallery image upload has failed. Please try uploading the image again.',
        );
      },
      onSuccess: (_, id) => {
        Promise.all([
          queryClient.invalidateQueries({
            queryKey: packageQueryKeys.lists(),
          }),
          queryClient.invalidateQueries({
            queryKey: packageQueryKeys.detail(id),
          }),
        ]);
        message.success('Package cover image has been deleted successfully');
      },
    },
  );
};
